<template lang="pug">
.content
  Errors(:errors='errors')

  h3.mt-3 Deleting the contractor will delete the authorisers for the contractor as well.
</template>

<script>
import { VueSlideoutForm } from "@/plugins/vue-form-slideout/VueSlideoutForm";
import { Contractors } from "@timesheets/webapp-support";
import { notify } from "./notify";

export default {
  name: "DeleteContractorConfirmationForm",

  extends: VueSlideoutForm,

  props: {
    id: {
      type: String,
      required: false,
      default: () => "deleteContractor",
    },
    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: {
        contractorId: this.options.contractorId,
      },
      notify,
      submitApiRequest: Contractors.DeleteContractor.submitApiRequest,
    };
  },
};
</script>
